'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _clamp2 = require('lodash/clamp');

var _clamp3 = _interopRequireDefault(_clamp2);

exports.allowInfinite = allowInfinite;
exports.inRange = inRange;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function modulo(x, y) {
    var remainder = x % y;
    if (remainder < 0) {
        return remainder + y;
    }
    return remainder;
}

function allowInfinite(infinite, totalSlides) {
    return infinite && totalSlides > 2;
}

function inRange(number, _ref) {
    var _ref$min = _ref.min,
        min = _ref$min === undefined ? 0 : _ref$min,
        max = _ref.max,
        infinite = _ref.infinite;

    return allowInfinite(infinite, max) ? modulo(number, max) + min : (0, _clamp3.default)(number, min, max - 1);
}
//# sourceMappingURL=util.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-carousel/lib/cjs/util.js
 ** module id = 288
 ** module chunks = 1
 **/